import { Dispatch, SetStateAction } from 'react';
import FilterRadioButton from '../../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../components/FilterRadioButtonsContainer';
import { SecondaryButton } from '../../../components/SecondaryButton';
import ExportXlsx from '../../../utils/ExportXlsx';
import { DataHeader as StyledDataHeader } from '../styles';
import { CsvParsedType, SelectedOptionType } from '../types';

interface DataHeaderInterface {
  setDataView: Dispatch<SetStateAction<'map' | 'list'>>;
  dataView: 'map' | 'list';
  selectedEmployee: SelectedOptionType;
  selectedDestinyWorkplace: SelectedOptionType;
  selectedCurrentWorkplace: SelectedOptionType;
  rawData: CsvParsedType[];
}

export default function DataHeader({
  setDataView,
  dataView,
  selectedEmployee,
  selectedDestinyWorkplace,
  selectedCurrentWorkplace,
  rawData,
}: DataHeaderInterface) {
  return (
    <StyledDataHeader>
      <FilterRadioButtonsContainer>
        <FilterRadioButton
          onClick={() => setDataView('map')}
          selected={dataView === 'map'}
        >
          Mapa
        </FilterRadioButton>
        <FilterRadioButton
          onClick={() => setDataView('list')}
          selected={dataView === 'list'}
        >
          Lista
        </FilterRadioButton>
      </FilterRadioButtonsContainer>

      {!!selectedEmployee.value && (
        <h1>{selectedEmployee.label}</h1>
      )}
      {!!selectedDestinyWorkplace.value && (
        <h1>{selectedDestinyWorkplace.label}</h1>
      )}
      {!!selectedCurrentWorkplace.value && (
        <h1>{selectedCurrentWorkplace.label}</h1>
      )}

      <SecondaryButton onClick={() => {
        ExportXlsx({
          data: rawData,
          filename: 'Dados de triangulação filtrados conforme visualização',
        });
      }}
      >
        Download CSV (de acordo com seleção)
      </SecondaryButton>
    </StyledDataHeader>
  );
}
